import { IS_BILLING, USER_TYPE } from "@/constants";
import { IUser, RegistrationType } from "@/modules/User/user.interface";

/**
 * Checks if the user has a customer record but no active subscription
 * These users should only have access to billing and account info routes
 */
export function isBillingOnlyUser(user: IUser | null): boolean {
  return Boolean(
    IS_BILLING &&
      user?.customer?.id &&
      !user?.customer?.subscription &&
      user?.customer?.stripeSyncStatus !== "pending"
  );
}

export function isUserBillingAdmin(
  user: IUser | null,
  doesPreviousUserExists: boolean
): boolean {
  // Users logged in as another user should not be treated as admin
  if (doesPreviousUserExists) return false;

  const adminType = getAdminByCustomerType(
    user?.customer?.registrationType || null
  );
  if (!adminType) return false;
  return Boolean(IS_BILLING && user?.Role.name === adminType);
}

/**
 * Checks if the user has a past_due subscription status
 * These users can access the app but should see payment warnings
 */
export function hasPaymentIssue(user: IUser | null): boolean {
  return Boolean(
    IS_BILLING && user?.customer?.subscription?.status === "past_due"
  );
}

/**
 * Checks if the user's subscription is currently being synced with Stripe
 */
export function isUserSyncing(user: IUser | null): boolean {
  return Boolean(
    IS_BILLING &&
      user?.customer?.id &&
      user?.customer?.stripeSyncStatus === "pending"
  );
}

/**
 * Checks if the user's subscription sync has failed
 */
export function isUserSyncFailed(user: IUser | null): boolean {
  return Boolean(
    IS_BILLING &&
      user?.customer?.id &&
      user?.customer?.stripeSyncStatus === "failed"
  );
}

function getAdminByCustomerType(registrationType: RegistrationType | null) {
  if (registrationType === "advertiser") {
    return USER_TYPE.ADVERTISER_ADMIN;
  }
  if (registrationType === "agency") {
    return USER_TYPE.AGENCY_ADMIN;
  }
  return null;
}
